<div>
    <quill-editor
        [placeholder]="_placeholder"
        [(ngModel)]="_value"
        (ngModelChange)="_onChangeCallback($event)"
        [required]="required"
        [sanitize]="true"
        [styles]="{ minHeight: inputMinHeight, height: inputFixedHeight }"
        [modules]="_modules"
    >
    </quill-editor>
</div>
